module.exports = {"jugar":"Jugar","instrucciones":"Instrucciones"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/home/es.json
// module id = 173
// module chunks = 12